var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showTooltip)?_c('b-tooltip',{attrs:{"label":_vm.presenter.tooltip,"dashed":"","multilined":"","position":"is-left"}},[_vm._v(" "+_vm._s(_vm.presenter.label)+" ")]):_c('span',[_vm._v(_vm._s(_vm.presenter.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }